<script setup lang="ts">
import { Link, useForm } from "@inertiajs/vue3"
import { UiButton, UiCnpjInput, UiFormLayout, UiSelect, UiTextInput } from "@/components"
import { useNotifications } from "@/composables/useNotifications"

type SupplierPayload = {
  id?: number | null
  company_id: number | ""
  name: string
  document: string
  email: string
}

const props = defineProps<{
  mode: "create" | "edit"
  title: string
  subtitle?: string
  supplier: SupplierPayload
  companies: Array<{ id: number; name: string }>
  errors?: Record<string, string[]>
}>()

const form = useForm({
  supplier: {
    company_id: props.supplier.company_id,
    name: props.supplier.name,
    document: props.supplier.document,
    email: props.supplier.email,
  },
})

const notify = useNotifications()
const fieldError = (field: string) => props.errors?.[field]?.[0]

function submit() {
  const opts = { onSuccess: () => notify.success(props.mode === "create" ? "Fornecedor criado com sucesso" : "Fornecedor atualizado com sucesso") }
  if (props.mode === "create") {
    form.post("/suppliers", opts)
    return
  }

  form.put(`/suppliers/${props.supplier.id}`, opts)
}
</script>

<template>
  <UiFormLayout :title="title" :subtitle="subtitle" back-href="/suppliers" back-label="Voltar para fornecedores">
    <form class="space-y-4" @submit.prevent="submit">
      <div class="grid gap-4 md:grid-cols-2">
        <UiSelect
          id="supplier-company"
          :model-value="form.supplier.company_id"
          label="Empresa"
          :options="companies.map((company) => ({ label: company.name, value: company.id }))"
          :disabled="mode === 'edit'"
          :error="fieldError('company') || fieldError('company_id')"
          @update:model-value="form.supplier.company_id = $event as number | ''"
        />

        <UiTextInput id="supplier-name" v-model="form.supplier.name" label="Nome" placeholder="Ex: Aco Brasil" :error="fieldError('name')" />

        <UiCnpjInput id="supplier-document" v-model="form.supplier.document" label="CNPJ" :error="fieldError('document')" />

        <UiTextInput id="supplier-email" v-model="form.supplier.email" type="email" label="E-mail" placeholder="compras@fornecedor.com" :error="fieldError('email')" />
      </div>

      <div class="flex items-center gap-3 pt-2">
        <UiButton type="submit" :disabled="form.processing">
          {{ mode === "create" ? "Criar fornecedor" : "Salvar alteracoes" }}
        </UiButton>

        <Link href="/suppliers" class="rounded-md border border-slate-300 px-4 py-2 text-sm font-medium text-slate-700 transition hover:bg-slate-100">
          Cancelar
        </Link>
      </div>
    </form>
  </UiFormLayout>
</template>
